import { render, staticRenderFns } from "./modal-edit-project-document-type.vue?vue&type=template&id=2aa70bc4&"
import script from "./modal-edit-project-document-type.vue?vue&type=script&lang=js&"
export * from "./modal-edit-project-document-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports